import manufacturerFilter from "./manufacturerFilter.json";
import wishlistActions from "./wishlistActions.json";
export default {
  manufacturerFilter,
  wishlistActions,
};
